// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 6755 ? "premiumcarousel.637162dd" : chunkId) + "--" + {"2292":"d454397","3543":"31a0dc3","3573":"60e5ec7","6755":"8c92923"}[chunkId] + ".css";
};